export enum CompanyReportSectionType {
  Details = 'details',
  Visibility = 'visibility',
  SavedReports = 'reports',
  Filters = 'filters',
  EmailSettings = 'emailSettings',
  ExcelMappings = 'excelMappings',
  Texts = 'texts',
  Metadata = 'metadata',
  Translations = 'translations'
}
